import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Add, Delete, Edit } from '@mui/icons-material';
import { Button } from '@mui/material';
import cn from 'classnames';

import { IFormDrugClassesControlProps } from './FormDrugClassesControl.interface';

import './style.scss';

const FormDrugClassesControl: FC<IFormDrugClassesControlProps> = ({
  className,
  value,
  onCreate,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation();

  return (
    <div className={cn('form-drug-classes-control', className)}>
      <div className="form-drug-classes-control__header">{t('admin.drugClasses')}</div>
      {value.length > 0 && (
        <div className="form-drug-classes-control__list">
          {value.map(item => (
            <div className="form-drug-classes-control__item" key={item.id}>
              <div className="form-drug-classes-control__name">{item.name}</div>

              <Button className="form-drug-classes-control__edit" onClick={() => onEdit(item)}>
                <Edit className="form-drug-classes-control__icon" />
                {t('admin.edit')}
              </Button>

              <Button className="form-drug-classes-control__delete" onClick={() => onDelete(item)}>
                <Delete className="form-drug-classes-control__icon" />
                {t('admin.delete')}
              </Button>
            </div>
          ))}
        </div>
      )}
      <Button variant="text" className="form-drug-classes-control__create-new" onClick={onCreate}>
        <Add className="form-drug-classes-control__icon" />
        {t('admin.addNewDrugClass')}
      </Button>
    </div>
  );
};

export default FormDrugClassesControl;
